export default {
  'zh-CN': {
    notFound: {
      message: '页面不存在',
      backHome: '返回首页'
    }
  },
  en: {
    notFound: {
      message: 'Page Not Found',
      backHome: 'Back to Home'
    }
  },
  ja: {
    notFound: {
      message: 'ページが見つかりません',
      backHome: 'ホームへ戻る'
    }
  },
  'zh-TW': {
    notFound: {
      message: '頁面不存在',
      backHome: '返回首頁'
    }
  }
}
